export const juniorLocales = [
    'da_DK',
    'de_DE',
    'en_GB',
    'es_ES',
    'fr_FR',
    'it_IT',
    'nb_NO',
    'pl_PL',
    'pt_PT',
    'sv_SE',
    'uk_UA',
    'fi_FI',
    'ro_RO',
    'cs_CZ',
];
export const abcLocales = ['sv_SE', 'da_DK', 'nb_NO', 'fi_FI'];
//# sourceMappingURL=constants.js.map